import React from "react";
import {IonContent, IonHeader, IonMenu, IonTitle, IonToolbar} from "@ionic/react";
import {useHistory, useLocation} from "react-router";

const menuItems = [
    { label: 'About AICAS', pathName:'/about-us' },
    { label: 'Become a Member', pathName: '/membership' },
    { label: 'Policy', pathName:'/policy' },
    { label: 'Deactivate Account', pathName:'/deactivate' },
    { label: 'Contact Us', pathName:'/contact-us' },
];

const versionNumber = `2.5.1`;

export default function WithoutLoginLeftSideMenuComponent({pageId,setCurrentPath,menuRef,isMobile,menuId}){
    const {pathname} = useLocation();
    const history = useHistory();

    const goToPage =(page)=>{
        const menu = menuRef.current;
        if(isMobile){
            history.replace(page);
            setCurrentPath(page);
            if (menu) {
                menu?.close();
            }
        }else{
            history.replace(page);
            setCurrentPath(page);
            if (menu) {
                menu?.close();
            }
        }
    }

    return(
        <>
            {/* Mobile/Tablet Slide Menu */}
            <IonMenu side="start" menuId={menuId} menuRef={menuRef} contentId={pageId}>
                <IonHeader className={"with_login-header"}>
                    <IonToolbar className={"with_login-toolbar in-left-menu"}>
                        <IonTitle>MENU</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <div className="with_login-mobile-menu">
                        {/* Close button at top of menu */}
                        {menuItems.map((item, index) => (
                            <div key={index} className="menu-section">
                                <div
                                    onClick={() => {
                                        if (item.pathName) {
                                            goToPage(item.pathName);
                                        }
                                    }}
                                    className={`with_login-menu-item menu-names ${
                                        pathname === item?.pathName ? 'active' : ''
                                    }`}
                                >
                                    <span>{item.label}</span>
                                </div>
                            </div>
                        ))}
                        <div className="menu-section">
                            <div
                                onClick={() => goToPage('/login')}
                                className={`with_login-menu-item menu-names ${
                                    pathname === '/login' ? 'active' : ''
                                }`}>
                                <span>Login</span>
                            </div>
                            <div
                                onClick={() => goToPage('/signup')}
                                className={`with_login-menu-item menu-names ${
                                    pathname === '/signup' ? 'active' : ''
                                }`}>
                                <span>Register</span>
                            </div>
                        </div>
                        <div className="with_login-menu-item version_no_section">
                            <div className={"version_no_section"}>Version {versionNumber}</div>
                        </div>
                    </div>
                </IonContent>
            </IonMenu>
        </>
    )
}